import { render, staticRenderFns } from "./consulta_costeo_inv.vue?vue&type=template&id=089d48f7&"
import script from "./consulta_costeo_inv.vue?vue&type=script&lang=js&"
export * from "./consulta_costeo_inv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports